import React, { useEffect } from 'react';
import 'dotenv';
import api from '../../services/api';
import Button from '../Campanhas/Button';

const loadFbLoginApi = () => {
    window.fbAsyncInit = () => {
        window.FB.init({
            appId: process.env.REACT_APP_FB_ID,
            status: true,
            cookie: true,
            xfbml: true,
            version: 'v7.0',
        });
    };

    // Load the SDK asynchronously
    (function LoadFBSKD(d, s, id) {
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        const js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/pt_BR/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
};

export const FacebookLogin = ({
 buttonText, setLoading, setFbtokenSent, setRefused, gtm,
}) => {
    useEffect(() => {
        loadFbLoginApi();
    }, []);

    const handleLogin = () => {
        setLoading(true);
        gtm.sendGtmMetrics('faceAuth');
        window.FB.login((response) => {
            setLoading(false);
            if (response.authResponse) {
                setRefused(false);
                // Envia token para o backend
                const tempToken = response.authResponse.accessToken;
                api.post('/api/v2/facebook/token', {
                    FBtoken: tempToken,
                }, {
                    validateStatus: () => true,
                })
                .then(() => setFbtokenSent(true));
            } else {
                setRefused(true);
            }
        });
    };
    return (
	<Button
		type="button"
		fontSize="12px"
		fit="253px"
		padding="11px 15px"
		height="48px"
		borderRadius="8px"
		theme="red"
		fontWeight="bold"
		onClick={handleLogin}
	>
		{ buttonText }
	</Button>
    );
};

export const FacebookLogout = () => {
    useEffect(() => {
        loadFbLoginApi();
    }, []);
    const handleLogout = () => {
        window.FB.logout();
    };
    return <button type="button" onClick={handleLogout}>LogOut</button>;
};

export default FacebookLogin;
